module.exports = __webpack_public_path__ + "assets/images/077d616fa2e26ebef4ee0816d752b51a.png";